import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { isValidEmailShape } from "@/lib/contact-lead"
import { useTranslations } from "next-intl"

interface ContactEmailFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  label?: string | null
  required?: boolean
}

const ContactEmailField = ({ form, label, required = true }: ContactEmailFieldProps) => {
  const t = useTranslations("ContactForm")
  const displayLabel = (label?.trim()) || t("email")

  return (
    <FormField
      control={form.control}
      name="email"
      rules={{
        required: required ? t("emailRequired") : false,
        // Shares `isValidEmailShape` with the route that enforces, so the field
        // cannot reject an address the server would have accepted. The pattern
        // here used to be ASCII-only and blocked unicode domains outright.
        validate: (value: string) =>
          !value || !value.trim() || isValidEmailShape(value) ? true : t("emailInvalid"),
      }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel htmlFor="email">{displayLabel}</FormLabel>
          <FormControl>
            <Input
              id="email"
              type="email"
              className="glass-panel"
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default ContactEmailField